export function useStringFormat() {
    function colKeyToLabel(string) {
        return string.replace(/_|#|-|@|<>/g, ' ')
            .replace(/(\w)(\w*)/g, function (g0, g1, g2) {
                return g1.toUpperCase() + g2.toLowerCase()
            })
    }
    function capitalizeFirstLetter(str = null) {
        if(str) {
            str = str.toLowerCase();
            let firstLetter = str.charAt(0).toUpperCase();
            return firstLetter + str.slice(1);
        }
        return str
    }


    return { colKeyToLabel, capitalizeFirstLetter }
}
